module.exports = __webpack_public_path__ + "img/1.b79c0d18.png";